import { MutableRefObject, useRef } from 'react';

import { NwAuthAPIServiceTypes } from '../../services/NwAuthServices/APIService';
import { NwAuthAPIService } from '../../services/NwAuthServices/APIService/index.api';
import { networkCallWithApisauce } from '../../utils/AuthAPIUtils';

const useNwAuthRefreshTokenAPIService = () => {
  const NwAuthRefreshTokenAPIRef: MutableRefObject<NwAuthAPIServiceTypes | null> =
    useRef(null);

  if (NwAuthRefreshTokenAPIRef.current === null) {
    NwAuthRefreshTokenAPIRef.current = new NwAuthAPIService(
      networkCallWithApisauce
    );
  }

  return {
    nwAuthRefreshTokenAPIService: NwAuthRefreshTokenAPIRef.current
  };
};

export { useNwAuthRefreshTokenAPIService };
